import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Text } from 'components/text/Text'
import { Error } from 'components/error/Error'

import styles from './Checkbox.module.scss'

export const Checkbox = ({
  checked = false,
  disabled = false,
  mixed = false,
  className,
  textLabel,
  error,
  showErrorText = true,
  onChange,
  dataTestId,
}) => (
  <div
    className={classNames(styles.checkbox, className, {
      [styles.mixed]: mixed,
      [styles.invalid]: error && !disabled,
      [styles.checked]: checked,
      [styles.disabled]: disabled,
    })}
    data-test-id={dataTestId}>
    <label>
      <input
        className={styles.input}
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        onChange={() => onChange(!checked)}
      />

      <Text lineHeight={1.6} color="greyBlue" className={styles.label}>
        {textLabel}
      </Text>
    </label>

    {error && showErrorText && <Error>{error}</Error>}
  </div>
)

Checkbox.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  mixed: PropTypes.bool,
  onChange: PropTypes.func,
  textLabel: PropTypes.string,
  error: PropTypes.string,
  showErrorText: PropTypes.bool,
}
